module.exports = __webpack_public_path__ + "img/227.dishwashing.36cafe31.svg";